import { LitElement, html, css } from 'lit-element';
import { FBP } from '@furo/fbp';
// import {i18n} from "@furo/framework";

import '@furo/data/src/furo-data-object.js';
import '@furo/data/src/furo-entity-agent.js';

import '@furo/data-input/src/furo-catalog.js';
import '@furo/data-input/src/furo-data-collection-dropdown.js';
import '@furo/form/src/furo-catalog.js';

import './make-empty-bes-object.js';
import '../../project-components/detail-button-bar.js';
import './bes-detail-form.js';

/**
 * `bes-detail`
 * Describe your element
 *
 * @summary shortdescription
 * @customElement
 * @demo demo/bes-detail.html
 * @appliesMixin FBP
 */
class BesDetail extends FBP(LitElement) {
  /**
   * Exposes --queryParams
   * @param {Object} det
   */
  setQp(det) {
    // setze auf edit wenn wir sco und arb haben
    this._FBPTriggerWire('--queryParams', det);
    // setze auf neu erstellen wenn wir nur sco haben

    if (det.bes === undefined) {
      this._FBPTriggerWire('--creatorQP', det);
    } else {
      this._FBPTriggerWire('--editQP', det);
    }
    // wir müssen nach dem delete nur den QP leer schicken, damit bes verschwindet
    this.deleteQP = {};
  }

  /**
   * flow is ready lifecycle method
   */
  _FBPReady() {
    super._FBPReady();
    // this._FBPTraceWires();
  }

  /**
   * @private
   * @returns {TemplateResult}
   */
  render() {
    // language=HTML
    return html`
      <furo-vertical-flex style="position: relative">
        <furo-banner-display autofocus=""></furo-banner-display>
        <furo-banner ƒ-parse-grpc-status="--error" icon="warning"></furo-banner>

        <bes-detail-form
          flex
          scroll
          ƒ-set-qp="--queryParams"
          ƒ-bind-data="--entityReady(*.data)"
          ƒ-object-collection-in="--objekteResponse"
          ƒ-raw-lagerorte-collection-in="--LagerortResponse"
          ƒ-start-activity="--saveClicked, --createClicked"
          ƒ-stop-activity="--dataLoaded, --saveSuccess, --emptyObject, --createSuccess, --error"
        >
        </bes-detail-form>

        <furo-ripple noink class="success" ƒ-trigger="--saveSuccess, --createSuccess"></furo-ripple>
        <detail-button-bar
          ƒ-bind-entity="--entityReady"
          @-save-clicked="--saveClicked"
          @-create-clicked="--createClicked"
          @-delete-clicked="--deleteClicked"
        >
        </detail-button-bar>
      </furo-vertical-flex>

      <!-- Ab hier die datenlogik-->
      <furo-deep-link
        service="Bestellung"
        ƒ-qp-in="--queryParams"
        @-hts-out="--hts"
      ></furo-deep-link>

      <make-empty-bes-object
        ƒ-qp-in="--creatorQP"
        @-object-created="--emptyObject"
      ></make-empty-bes-object>

      <furo-entity-agent
        service="Bestellung"
        ƒ-hts-in="--hts"
        ƒ-load="--editQP"
        ƒ-bind-request-data="--entityReady(*.data)"
        ƒ-delete="--deleteClicked"
        @-delete-success="^^bestellung-deleted(deleteQP)"
        @-save-success="--saveSuccess, ^^bestellung-saved"
        @-create-success="--createSuccess, ^^bestellung-created"
        ƒ-save="--saveClicked, --createClicked"
        @-load-success="--dataLoaded"
        @-response-error="--error"
      ></furo-entity-agent>

      <furo-data-object
        type="bestellung.BestellungEntity"
        ƒ-clear-all-errors="--dataLoaded, --saveSuccess, --emptyObject, --createSuccess"
        ƒ-inject-raw="--dataLoaded, --saveSuccess, --emptyObject, --createSuccess"
        @-object-ready="--entityReady"
      ></furo-data-object>
    `;
  }

  /**
   *
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return css`
      :host {
        display: block;
        background-color: var(--surface, white);
        font-size: 14px;
        padding: 12px 24px;
        height: 100%;
        box-sizing: border-box;
      }

      furo-ripple.success {
        --furo-ripple-bg-color: var(--success, #5ef47f);
      }

      furo-banner-display {
        --furo-icon-fill-color: var(--danger, red);
      }
      bes-detail-form {
        margin-top: 12px;
      }
    `;
  }
}

window.customElements.define('bes-detail', BesDetail);
